<style lang="less" scoped>
  .reset-password-container {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100vh;
    padding: 0 72px;
  }
  .form {
    width: 300px;
  }
  .title {
    margin-bottom: 32px;
    font-size: 1.8em;
  }
  .input-group {
    position: relative;
    height: 50px;
    border-bottom: 1px solid #e0e4e6;
  }
  .label {
    position: absolute;
    top: 0;
    left: 0;
    font-size: 12px;
    line-height: 50px;
    color: #909090;
  }
  .input {
    width: 100%;
    height: 100%;
    border: 0;
    line-height: 50px;
    background-color: transparent;
    box-shadow: none;
    font-size: 13px;
    text-align: right;
  }
  .button {
    display: block;
    width: 100%;
    height: 32px;
    margin-top: 16px;
    padding: 0 16px;
    border: 1px solid #222;
    background-color: #fff;
    line-height: 32px;
    text-align: center;
    &:hover {
      color: #ff6b00;
      border-color: #ff6b00;
    }
  }
</style>

<template lang="pug">
  section.reset-password-container
    form.form(@submit.prevent="submit")
      h1.title 스타일닷컴 비밀번호 재설정
      .input-group
        label.label(for="js-find-password") 비밀번호
        input.input(
          type="password",
          v-model="password")
      .input-group
        label.label(for="js-find-password-validity") 비밀번호 확인
        input.input(
          type="password",
          v-model="passwordValidity")
      button.button 확인
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'ResetPassword',
  computed: {
    ...mapState({
      key: state => decodeURIComponent(state.route.query.key),
    }),
  },
  data() {
    return {
      password: null,
      passwordValidity: null,
    };
  },
  methods: {
    async submit() {
      if (this.password !== this.passwordValidity) {
        this.$message.error('비밀번호 확인은 비밀번호와 일치해야 합니다');
        return;
      }
      try {
        await this.$http.post('/api/mkc/v1/reset-passwd', {
          key: this.key,
          passwd: this.password,
        });
        this.$router.push('/');
      } catch (e) {
        console.log(e);
        if (!!e.response.data && !!e.response.data.message) {
          this.$message.error(e.response.data.message);
        }
      }
    },
  },
};
</script>
